import React from 'react';
import { Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';

export default function ErrorAlert({ error }: ErrorAlertProps) {
  if (error === '') {
    return null;
  }

  return (
    <Alert bsStyle="danger" className="d-flex">
      <div>
        <FontAwesomeIcon icon={faExclamationCircle} size="3x"/>
      </div>
      <div className="ml-3 mt-1">
        <h3 className="mt-0 mb-2">{error}</h3>
        <strong>Please try again or contact support for help.</strong>
      </div>
    </Alert>
  );
}

type ErrorAlertProps = {
  error: string;
};
